module.exports = __webpack_public_path__ + "static/media/img3-2.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/B/img3-2.png
// module id = 1635
// module chunks = 3